
import { Product } from './types';

export const CATEGORIES = [
  "ALL",
  "커넥트",
  "테크닉",
  "익사이팅",
  "네모",
  "말랑말랑코딩",
  "AI비누"
];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: "conn-001",
    categories: ["커넥트"],
    name: "커넥트 베이직 1호 (기초 구조 학습)",
    price: 29700,
    originalPrice: 33000,
    image: "https://picsum.photos/400/400?random=10",
    description: "<p>다양한 구조물을 직접 조립하며 <strong>기계 원리</strong>를 배우는 기초 메이커 세트입니다.</p>",
    isNew: true,
    stock: 50,
    shippingFee: 3000,
    options: [],
    addOns: []
  },
  {
    id: "ai-001",
    categories: ["AI비누"],
    name: "AI 비누(VINU) 스타터 키트",
    price: 116000,
    originalPrice: 145000,
    image: "https://picsum.photos/400/400?random=60",
    description: "<p>인공지능 비전 센서를 활용한 자율주행 학습 키트입니다.</p>",
    isNew: true,
    stock: 8,
    shippingFee: 0,
    options: [],
    addOns: []
  }
];

/** 
 * 결제 설정 - 포트원 + KG이니시스
 */
export const PORTONE_USER_CODE = "imp07274844";
export const PG_PROVIDER = "html5_inicis"; // KG이니시스(웹표준) 결제 연동
